import { Inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { LsqDataTableComponent } from '../table/components/data-table/lsq-data-table.component';

@Pipe({
    name: 'getOffsetIndexOfSiblingRow'
})
export class GetOffsetIndexOfSiblingRowPipe implements PipeTransform {
    constructor(
        @Inject(LsqDataTableComponent)
        private _dataTable: LsqDataTableComponent
    ) {}

    public transform(
        row: any,
        index: number,
        refKeyInCommon: string,
        parentRowFlag: string
    ): Observable<number> {
        return this._dataTable.dataSource.rows$.pipe(
            first(),
            map((rows) =>
                rows.findIndex(
                    (candidateRow) =>
                        candidateRow[parentRowFlag] &&
                        candidateRow[refKeyInCommon] === row[refKeyInCommon]
                )
            ),
            map((indexOfParentRow) => index - indexOfParentRow)
        );
    }
}
